(() => {
  function enhanceDescription(root) {
    if (root.dataset.lzReady) return;
    root.dataset.lzReady = 'true';
    const ordering = [];
    Array.from(root.querySelectorAll('p,h1,h2,h3,h4,h5,h6')).forEach(node => {
      const text = node.textContent.trim();
      if (/^(?:minimum\s+(?:online\s+)?order|\(?price is per gram)/i.test(text) && !/order|pack/i.test(node.previousElementSibling?.matches('h1,h2,h3,h4,h5,h6') ? node.previousElementSibling.textContent : '') && text.length < 220 && !/benefits/i.test(text) && !node.querySelector('table,ul,ol')) {
        ordering.push(node);
        node.remove();
      }
    });
    const headings = Array.from(root.querySelectorAll('h1,h2,h3,h4,h5,h6')).filter(h => h.textContent.trim() && h.textContent.trim().length < 120 && !h.querySelector('a,img') && !h.closest('table,details'));
    const entries = [];
    let intro;
    const before = document.createRange();
    before.selectNodeContents(root);
    if (headings.length) before.setEndBefore(headings[0]);
    intro = before.cloneContents();
    headings.forEach((heading,index) => {
      const range = document.createRange();
      range.selectNodeContents(root);
      range.setStartAfter(heading);
      if (headings[index+1]) range.setEndBefore(headings[index+1]);
      const label = heading.textContent.trim();
      const rank = /benefit/i.test(label) ? 0 : /order|pack(?:age)?(?:d)? size|pack details|plastic.free shopping/i.test(label) ? 2 : 1;
      entries.push({label,content:range.cloneContents(),rank});
    });
    if (!headings.length && !intro.textContent.trim() && !intro.querySelector('img,video,iframe')) {
      ordering.forEach(node => root.append(node));
      return;
    }
    root.replaceChildren();
    const makeDetails = (label,content,open) => {
      const details = document.createElement('details');
      const summary = document.createElement('summary');
      summary.textContent = label;
      details.append(summary,content);
      details.open = open;
      root.append(details);
    };
    if (intro.textContent.trim() || intro.querySelector('img,video,iframe')) {
      if (headings.length) makeDetails(root.dataset.detailsLabel,intro,false);
      else makeDetails(root.dataset.detailsLabel,intro,true);
    }
    if (entries.length > 1 && entries.some(e => e.rank === 0) && entries[0].rank === 1 && !/description|details|ingredients|nutrition|care|storage|origin|how to/i.test(entries[0].label)) {
      const first = entries.shift();
      const heading = document.createElement('h2');
      heading.textContent = first.label;
      root.append(heading,first.content);
    }
    entries.sort((a,b) => a.rank-b.rank).forEach((entry,index) => {
      makeDetails(entry.label,entry.content,entry.rank===0 || entries.length===1 && index===0);
    });
    if (ordering.length) {
      const content = document.createDocumentFragment();
      ordering.forEach(node => content.append(node));
      makeDetails(root.dataset.orderingLabel,content,false);
    }
  }
  function setup() {
    document.querySelectorAll('[data-lz-description]').forEach(enhanceDescription);
    document.querySelectorAll('[data-lz-product-config]').forEach(config => {
      if (config.dataset.ready) return;
      config.dataset.ready = 'true';
      const minimum = Number(config.dataset.minimum);
      if (!(minimum > 0)) return;
      const form = document.getElementById('product_form_' + config.dataset.productId);
      if (!form) return;
      const input = form.querySelector('[name="quantity"]');
      const total = form.querySelector('#lz-total');
      const variants = JSON.parse(config.querySelector('[data-lz-variants]').textContent);
      const update = () => {
        const quantity = Number(input.value);
        const selected = form.querySelector('[name="id"]');
        const variant = variants.find(v => String(v.id)===selected.value) || variants[0];
        input.setCustomValidity(Number.isInteger(quantity) && quantity >= minimum ? '' : config.dataset.minimumError);
        total.textContent = config.dataset.totalLabel + ' ' + new Intl.NumberFormat('en-HK',{style:'currency',currency:config.dataset.currency}).format((Number.isFinite(quantity)?quantity:0)*variant.price/100);
      };
      input.addEventListener('input',update);
      form.addEventListener('change',update);
      const guard = event => {
        update();
        if (!input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          input.reportValidity();
        }
      };
      form.addEventListener('submit',guard,true);
      form.addEventListener('click',event => {
        if (event.target.closest('[type="submit"],.shopify-payment-button')) guard(event);
      },true);
      update();
    });
  }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup);
  else setup();
  document.addEventListener('shopify:section:load',setup);
})();
